import { render } from "./HomeComponent.vue?vue&type=template&id=27687a0e"
const script = {}

import exportComponent from "../../../biotron-complaint-20260813/WebMidiVue-integrated/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__